<template>
    <div :style="'width: 98%;margin: auto;'">
       <el-button  style="position: absolute;top: 5px;right: 25px;cursor: pointer;z-index: 999;" type="text" @click="helpTif">帮助视频</el-button>
        <el-tabs v-model="conActiveName" @tab-click="handleClick">
            <el-tab-pane label="信息配置" name="first">
                <div :style="'display: flex; width: 100%;margin: auto;'">
                    <div style="width: 27%;border-right: none;">
                        <div>
                            <div style="border: 1px solid gray;border-bottom:none;padding: 8px 0px;">
                                <el-image style="width: 17px; height: 17px;position: relative;left: 5px;top: 2px;" :src="require('../assets/muban.png')"></el-image>
                                <span style="display: inline-block;margin-left: 7px;font-weight: 550;">源模板</span>
                            </div>
                            <div id="sourceTemplate" @mouseup="clearStartName">
                                <div style="position: absolute;top:42px;left: 4%;z-index: 1;">
                                    <el-button @click="sourceStructure" size="mini" type="primary">生成源结构</el-button>
                                    <el-button @click="clearSourceTemplate" size="mini" type="primary">清空源模板</el-button>
                                </div>
                                <!-- <vue-json-editor v-model="sourceTemplate" lang="zh" :modes="[]" :show-btns="false" :mode="'code'" :expanded-on-start="true" /> -->
                                <div id="jsoneditor" style="height: 350px;"></div>
                            </div>
                            <div style="border: 1px solid gray; border-top: none;">
                                <div>
                                    <div style="padding: 8px 0px;">
                                        <el-image style="width: 17px; height: 17px;position: relative;left: 5px;top: 2px;" :src="require('../assets/jiegou.png')"></el-image>
                                        <span style="display: inline-block;margin-left: 7px;font-weight: 550;">源结构</span>
                                        <span style="font-size: 14px">（请选择黑色粗体的Key）</span>
                                    </div>
                                    <div style="overflow-y: auto;border-top: 1px solid gray;" @mouseup="clearStartName" @mousemove="handleDragMove">
                                        <el-tree empty-text="御控物联，JSON数据结构转换" :expand-on-click-node="false" id="sourceTree" :style="'height:'+(tableHeight - 525)+'px;overflow:auto;min-width: 100%;font-size: 14px;'" class="treeClass" :data="sourceData" :props="defaultProps" default-expand-all>
                                            <div slot-scope="{ node, data }">
                                                <div v-if="!Array.isArray(data)">
                                                    <span @mousedown="handleDragStart" @mouseup="clearStartName" :name="'!@#'+data.name" style="user-select:none;cursor: pointer;font-weight: 600;">{{ data.key }}：</span>
                                                    <span v-if="data.value&&(typeof data.value != 'object')" style="user-select:none;">{{ data.value }}</span>
                                                </div>
                                                <div v-else>
                                                    <span @mousedown="handleDragStartIndex" @mouseup="clearStartName" :name="upNames(data[0].name)" style="user-select:none;cursor: pointer;font-weight: 600;">{{ handleDragClicks(data[0]) }}&nbsp;：</span>
                                                    <div style="margin-left: 45px;margin-top: -20px;">
                                                        <span style="user-select:none;">{</span>
                                                        <div v-for="(item,index) in data" :key="index">
                                                            <div style="margin-left: 20px;">
                                                                <span @mousedown="handleDragStart" @mouseup="clearStartName" :name="'!@#'+item.name" style="user-select:none;cursor: pointer;font-weight: 600;">{{ item.key }}：</span>
                                                                <span v-if="item.children&&item.children.length==0" style="user-select:none;">{{ item.value }}</span>
                                                                <div v-if="item.children&&item.children.length>0">
                                                                    <recursionTree :data="item.children" @handleDragStartIndex="handleDragStartIndexRecursion" @handleDragStart="handleDragStartRecursion" @clearStartName="clearStartNameRecursion"></recursionTree>
                                                                </div>
                                                                <div v-else>
                                                                    <div v-if="Array.isArray(item)&&item.length>0">
                                                                        <recursionTree :data="item" @handleDragStartIndex="handleDragStartIndexRecursion" @handleDragStart="handleDragStartRecursion" @clearStartName="clearStartNameRecursion"></recursionTree>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <span style="user-select:none;">}</span>
                                                    </div>
                                                </div>
                                            </div> 
                                        </el-tree>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="width: 27%; ">
                        <div>
                            <div style="border: 1px solid gray;border-bottom: none;border-left:none ;padding: 8px 0px;">
                                <el-image style="width: 17px; height: 17px;position: relative;left: 5px;top: 2px;" :src="require('../assets/muban.png')"></el-image>
                                <span style="display: inline-block;margin-left: 7px;font-weight: 550;">目标模板</span>
                            </div>
                            <div id="targetTemplate" @mouseup="clearStartName">
                                <div style="position: absolute;top:42px;left: 31%;z-index: 1;">
                                    <el-button @click="targetStructure" size="mini" type="primary">生成目标结构</el-button>
                                    <el-button @click="clearTargetTemplate" size="mini" type="primary">清空目标模板</el-button>
                                </div>
                                <!-- <vue-json-editor v-model="targetTemplate" lang="zh" :modes="[]" :show-btns="false" :mode="'code'" :expanded-on-start="true" /> -->
                                <div id="jsoneditor1" style="height: 350px;"></div>
                            </div>
                            <div style="border: 1px solid gray; border-top: none;border-left: none;">
                                <div style="padding: 8px 0px;">
                                    <el-image style="width: 17px; height: 17px;position: relative;left: 5px;top: 2px;" :src="require('../assets/jiegou.png')"></el-image>
                                    <span style="display: inline-block;margin-left: 7px;font-weight: 550;">目标结构</span>
                                    <span v-if="startName" style="font-size: 14px">（请拖拽到绿色粗体的Key）</span>
                                </div>
                                <div style=" overflow-y: auto;border-top: 1px solid gray;" @mousemove="handleDragMove" @mouseup="handleDragUpss">
                                    <el-tree empty-text="御控物联，JSON数据结构转换" :expand-on-click-node="false" id="targetTree" :style="'height:'+(tableHeight - 525)+'px;overflow:auto;min-width: 100%;font-size: 14px;'" class="treeClass" :data="targetData" :props="defaultProps" default-expand-all>
                                        <div slot-scope="{ data }">
                                            <div v-if="!Array.isArray(data)">
                                                <span @mouseup="handleDragUp" @mousedown="clearStartName" :name="'#@!'+data.name" style="user-select:none;cursor: pointer;font-weight: 600;">{{ data.key }}：</span>
                                                <span v-if="data.value&&(typeof data.value != 'object')" style="user-select:none;">{{ data.value }}</span>
                                            </div>
                                            <div v-else>
                                                <span @mouseup="handleDragUpIndex" @mousedown="clearStartName" :name="upNamess(data[0].name)" style="user-select:none;cursor: pointer;font-weight: 600;">{{ handleDragClicks(data[0]) }}：</span>
                                                <div style="margin-left: 45px;margin-top: -20px;">
                                                    <span style="user-select:none;">{</span>
                                                    <div v-for="(item,index) in data" :key="index">
                                                        <div style="margin-left: 20px;">
                                                            <span @mouseup="handleDragUp" @mousedown="clearStartName" :name="'#@!'+item.name" style="user-select:none;cursor: pointer;font-weight: 600;">{{ item.key }}：</span>
                                                            <span v-if="item.children&&item.children.length==0" style="user-select:none;">{{ item.value }}</span>
                                                            <div v-if="item.children&&item.children.length>0">
                                                                <recursiontargetTree @handleDragUpIndex="handleDragUpIndexRecursion" :data="item.children" @handleDragUp="handleDragUpRecursion" @clearStartName="clearStartNameRecursion"></recursiontargetTree>
                                                            </div>
                                                            <div v-else>
                                                                <div v-if="Array.isArray(item)">
                                                                    <recursiontargetTree @handleDragUpIndex="handleDragUpIndexRecursion" :data="item" @handleDragUp="handleDragUpRecursion" @clearStartName="clearStartNameRecursion"></recursiontargetTree>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span style="user-select:none;">}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </el-tree>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div :style="'width: 46%;border: 1px solid gray;border-left: none;'" @mouseup="clearStartName">
                        <div>
                            <div style="padding: 8px 0px;">
                                <el-image style="width: 17px; height: 17px;position: relative;left: 5px;top: 2px;" :src="require('../assets/guanxi.png')"></el-image>
                                <span style="display: inline-block;margin-left: 7px;font-weight: 550;">对应关系</span>
                            </div>
                            <el-table ref="relationshipTable"  class="custom-expand-table"   :data="tableData" :style="'width: 100%;'" :height="(tableHeight - 165)" border @selection-change="handleSelectionChange">
                                <el-table-column min-width="55" type="selection" align="center"></el-table-column>
                                <el-table-column align="center"  type="expand"  width="80" label="高级"  >
                                    <template slot-scope="scope">
                                        <div style="background-color: #F4F8FB;">
                                            <div style="width: 96%;margin: auto">
                                                <el-form :model="scope.row" label-width="100px">
                                                    <el-row style="display: flex; flex-wrap: wrap; justify-content: left">
                                                        <el-col :span="12">
                                                            <el-form-item>
                                                                <template slot="label">
                                                                    起始索引
                                                                    <el-tooltip effect="dark" :content="'自动生成的元素的起始索引'" placement="top">
                                                                        <i class="el-icon-question"></i>
                                                                    </el-tooltip>
                                                                </template>

                                                                <el-input-number size="mini" v-model="scope.row.Options.KeyInitIndex" :min="0"></el-input-number>
                                                            </el-form-item>
                                                        </el-col>
                                                        <el-col :span="12">
                                                            <el-form-item>
                                                                <template slot="label">
                                                                    追加/替换
                                                                    <el-tooltip effect="dark" :content="'追加：不清空目标元素；替换：清空目标元素'" placement="top">
                                                                        <i class="el-icon-question"></i>
                                                                    </el-tooltip>
                                                                </template>
                                                                <el-radio-group v-model="scope.row.Options.AddElementsOption">
                                                                    <el-radio :label="'1'">追加</el-radio>
                                                                    <el-radio :label="'2'">替换</el-radio>
                                                                </el-radio-group>
                                                            </el-form-item>
                                                        </el-col>
                                                        <el-col :span="24">
                                                            <el-form-item>
                                                                <template slot="label">
                                                                    转换操作
                                                                    <el-tooltip effect="dark" :content="'复制源子元素（原Key）：将源子元素复制到目标，使用源子元素的Key ；复制源子元素（新Key）：将源子元素复制到目标，为目标子元素新生成Key ;复制目标子元素：依据源元素在目标构建同等数量的目标子元素'" placement="top">
                                                                        <i class="el-icon-question"></i>
                                                                    </el-tooltip>
                                                                </template>
                                                                <el-radio-group v-model="scope.row.Options.TranOP">
                                                                    <el-radio :label="'1'">复制源子元素(原Key)</el-radio>
                                                                    <el-radio :label="'2'">复制源子元素(新Key)</el-radio>
                                                                    <el-radio :label="'3'">复制目标子元素</el-radio>
                                                                </el-radio-group>
                                                            </el-form-item>
                                                        </el-col>
                                                        <el-col :span="12">
                                                            <el-form-item>
                                                                <template slot="label">
                                                                    转换映射
                                                                    <el-tooltip effect="dark" :content="'交叉映射；一对一映射：仅在当前映射为规则映射（包含*、[*]）和上级元素指定【转换操作为复制目标子元素】时生效'" placement="top">
                                                                        <i class="el-icon-question"></i>
                                                                    </el-tooltip>
                                                                </template>
                                                                <el-radio-group v-model="scope.row.Options.TranWay">
                                                                    <el-radio :label="'1'">交叉映射</el-radio>
                                                                    <el-radio :label="'2'">一对一映射</el-radio>
                                                                </el-radio-group>
                                                            </el-form-item>
                                                        </el-col>
                                                    </el-row>
                                                </el-form>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="80" label="序号" align="center">
                                    <template slot-scope="scope">
                                        <el-input size="mini" v-model="scope.row.index" @input="handleInput($event,scope.$index)" @blur="handleBlur(scope.row.index,scope.$index)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="源路径" min-width="165" align="center">
                                    <template slot-scope="scope">
                                        <el-tooltip  effect="light" :content="scope.row.sourcePath" placement="right-start"  :offset="-100" transition="" >
                                            <el-input size="mini" :style="{ border: scope.row.sourcePathCheck ? '1px solid red' : 'none' }" @focus="fosourcePathCheck(scope.$index)" clearable v-model="scope.row.sourcePath"></el-input>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                                <el-table-column label="目标路径" min-width="165" align="center">
                                    <template slot-scope="scope">
                                        <el-tooltip effect="light" :content="scope.row.targetPath" placement="right-start"  :offset="-100"  transition="" >
                                            <el-input size="mini" :style="{ border: scope.row.targetPathCheck ? '1px solid red' : 'none' }" @focus="fotargetPathCheck(scope.$index)" clearable v-model="scope.row.targetPath"></el-input>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                                <el-table-column label="对应关系" min-width="145" align="center">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.relationShip" placeholder="请选择" clearable size="mini">
                                            <el-option v-for="item in relationShipOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" min-width="160" align="center">
                                    <template slot-scope="scope">
                                        <!-- <el-button type="primary" size="mini" @click="handleExpand(scope.row)">高级设置</el-button> -->
                                        <el-button type="danger" size="mini" @click="delShip(scope.$index)">删除</el-button>
                                        <el-button icon="el-icon-plus" size="mini" @click="addShip(scope.$index)"></el-button>
                                    </template>
                                </el-table-column>
                                <template slot="empty">
                                    <div class="emptyImg"></div>
                                    <div style="font-size: 18px;color: #e7e9ee;">御控物联，JSON数据结构转换</div>
                                </template>
                            </el-table>
                            <div style="float: right;">
                                <el-button size="mini" type="primary" @click="addTableData">新增</el-button>
                                <el-button size="mini" type="danger" @click="delTableData">删除</el-button>
                                <el-button size="mini" type="success" @click="inspect">检验</el-button>
                                <el-button size="mini" type="success" @click="preview">预览</el-button>
                                <el-button size="mini" type="warning" @click="tranLogsView">运行日志</el-button>
                                <el-button size="mini" type="danger" @click="tranErrorsView">错误日志</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="信息转换" name="second">
                <div style="display: flex; width: 98%;margin: auto;border: 1px solid gray;">
                    <div style="width: 45%;" class="editorBottom">
                        <div style="padding: 8px 0px;">
                            <el-image style="width: 17px; height: 17px;position: relative;left: 5px;top: 2px;" :src="require('../assets/baowen.png')"></el-image>
                            <span style="display: inline-block;margin-left: 7px;font-weight: 550;">源报文</span>
                        </div>
                        <!-- <vue-json-editor v-model="messageTemplate" lang="zh" :modes="[]" :show-btns="false" :mode="'code'" :expanded-on-start="true" /> -->
                        <div id="messageTemplateDom"></div>
                    </div>
                    <div style="width: 10%;text-align: center; display: flex;align-items: center;justify-content: center;height: 500px;">
                        <div>
                            <el-button size="mini" @click="importMes" type="primary" style="margin-bottom: 15px;">对应关系</el-button>
                            <br />
                            <el-button size="mini" @click="generateMessage" type="primary" style="margin-bottom: 15px;" >生成报文</el-button>
                            <br />
                            <el-button size="mini" type="warning" @click="tranLogsView" style="margin-bottom: 15px;">运行日志</el-button>
                            <br />
                             <el-button size="mini" type="danger" @click="tranErrorsView">错误日志</el-button>
                        </div>
                    </div>
                    <div style="width: 45%; " class="editorBottom1">
                        <div style="padding: 8px 0px;">
                            <el-image style="width: 17px; height: 17px;position: relative;left: 5px;top: 2px;" :src="require('../assets/baowen.png')"></el-image>
                            <span style="display: inline-block;margin-left: 7px;font-weight: 550;">转换后的报文</span>
                        </div>
                        <!-- <vue-json-editor v-model="messageedTemplate" lang="zh" :modes="[]" :show-btns="false" :mode="'code'" :expanded-on-start="true" /> -->
                        <div id="messageedTemplateDom"></div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <div  style="width: 30%;text-align: center;margin: 5px auto 0 auto; font-size: 11px;color: #999999;">©2024  荏原电产（青岛）科技有限公司</div>
        <div id="tooltip" style=" position: absolute;z-index: 9999; ">
            <el-select v-model="relationShip" placeholder="请选择" @change="showShip" size="mini">
                <el-option v-for="item in relationShipOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-button @click="cancelShip" size="mini" type="danger">取消</el-button>
        </div>
        <el-drawer title="预览" :visible.sync="previewDia" :wrapperClosable="true">
            <el-tabs v-model="vertActiveName" style="width: 98%;margin: auto;">
                <el-tab-pane label="预览结果" name="first" class="comDrawer">
                    <vue-json-editor v-model="previewTemplate" lang="zh" :modes="[]" :show-btns="false" :mode="'code'" :expanded-on-start="true" />
                </el-tab-pane>
                <el-tab-pane label="转换信息" name="second" class="comDrawer">
                    <vue-json-editor :key="finalTemplateKey" v-model="finalTemplate" lang="zh" :modes="[]" :show-btns="false" :mode="'code'" :expanded-on-start="true" />
                </el-tab-pane>
            </el-tabs>
            <div style="float: right;">
                <el-button size="mini" style="margin-top: 5px;margin-right: 5px;" type="primary" @click="previewDia =false">确定</el-button>
            </div>
        </el-drawer>
        <el-drawer title="对应关系" :visible.sync="importDia" :wrapperClosable="true">
            <div class="impDrawer">
                <!-- <vue-json-editor style="padding:  5px;" v-model="resultTemplate" lang="zh" :modes="[]" :show-btns="false" :mode="'code'" :expanded-on-start="true" /> -->
                <div id="resultTemplateDom"></div>
            </div>
            <div style="float: right;">
                <el-button size="mini" style="margin-right: 5px;" type="primary" @click="importDia =false">确定</el-button>
            </div>
        </el-drawer>
        <div class="custom-cursor" v-show="startName!=''">{{ startName }}</div>
        <el-dialog :title="viewTitle[viewIndex]" :visible.sync="dialogVisible" width="50%"  >
             <div style="height: 500px;overflow: auto; white-space: nowrap;background-color:#F8F8F8;">
                <div v-for="(item,index) in viewData" :key="index">
                   <div style="margin:2px 0;">
                    {{index+1}}：{{item  }}
                   </div>
                </div>
             </div>
        </el-dialog>
        <el-dialog :title="'帮助视频'" :visible.sync="promptDia" width="40%"  > 
            <img id="gifPlayer" style="width:100%;" src="../assets/prompt.gif" alt="GIF Player">
        </el-dialog>
    </div>
</template>
  <script  >
import vueJsonEditor from "vue-json-editor";
import recursionTree from "./recursionTree.vue";
import recursiontargetTree from "./recursiontargetTree.vue";
import JsonTranferUtil from "./json_transfer";
import JSONEditor from "jsoneditor";
import "jsoneditor/dist/jsoneditor.min.css"; // 引入样式
export default {
    components: { vueJsonEditor, recursionTree, recursiontargetTree },
    data() {
        return {
            promptDia:false,
            viewIndex:0,
            viewData:[],
            dialogVisible:false,
            viewTitle:["运行日志","错误日志"],
            tranLogsData: [],
            tranErrorsData: [],
            classStartName: "",
            startNameCopy: "",
            finalTemplateKey: "finalTemplateKey",
            multipleSelection: [],
            resultTemplate: null,
            importDia: false,
            messageTemplate: null,
            messageedTemplate: null,
            conActiveName: "first",
            vertActiveName: "first",
            finalTemplate: null,
            previewDia: false,
            previewTemplate: {},
            relationShipOptions: [
                { label: "源Key->目标Key", value: 1 },
                { label: "源Key->目标value", value: 2 },
                { label: "源value->目标key", value: 3 },
                { label: "源value->目标Value", value: 4 },
            ],
            relationShip: "",
            tableData: [],
            defaultProps: {
                children: "children",
                label: "key",
            },
            sourceData: [],
            targetData: [],
            hasJsonFlag: true, // json是否验证通过
            hasJsonFlag1: true,
            sourceTemplate: null,
            targetTemplate: null,
            showNumber: true,
            lint: true,
            readonly: false,
            wrap: true,
            theme: "idea",
            startName: "",
            upName: "",
            tableHeight: 875,
            targetPathData: [],
            sourcePathData: [],
            sourceTemplateDom: null,
            targetTemplateDom: null,
            messageTemplateDom: null,
            messageedTemplateDom: null,
            resultTemplateDom: null,
        };
    },
    watch: {},
    mounted() {
        var container = document.getElementById("jsoneditor");
        var options = {
            mode: "code",
        };
        this.sourceTemplateDom = new JSONEditor(container, options);
        try {
            this.sourceTemplateDom.set();
        } catch {}

        var container1 = document.getElementById("jsoneditor1");
        var options1 = {
            mode: "code",
        };
        this.targetTemplateDom = new JSONEditor(container1, options1);
        try {
            this.targetTemplateDom.set();
        } catch {}

        var container2 = document.getElementById("messageTemplateDom");
        var options2 = {
            mode: "code",
        };
        this.messageTemplateDom = new JSONEditor(container2, options2);
        try {
            this.messageTemplateDom.set();
        } catch {}
        var container3 = document.getElementById("messageedTemplateDom");
        var options3 = {
            mode: "code",
        };
        this.messageedTemplateDom = new JSONEditor(container3, options3);
        try {
            this.messageedTemplateDom.set();
        } catch {}

        this.$nextTick(() => {
            this.cancelShip();
            this.tableHeight = window.innerHeight;
            window.addEventListener("resize", () => {
                this.tableHeight = window.innerHeight;
            });
            window.addEventListener("mouseup", () => {
                if (this.targetPathData && this.targetPathData.length > 0) {
                    this.targetPathData = Array.from(
                        new Set(this.targetPathData)
                    );
                    this.targetPathData.forEach((item) => {
                        let ele = document.getElementsByName(item);
                        if (ele && ele.length > 0) {
                            ele[0].style.color = "#606266";
                        }
                    });
                }
                this.handleDragUpss();
            });
            // 监听鼠标移动事件
            document.addEventListener("mousemove", function (e) {
                // 更新鼠标样式的位置
                document.querySelector(".custom-cursor").style.top =
                    e.clientY + "px";
                document.querySelector(".custom-cursor").style.left =
                    e.clientX + 15 + "px";
            });
        });
    },
    methods: {
        // 帮助gif 
        helpTif(){
            this.promptDia=true
            this.$nextTick(()=>{
                 // 获取 <img> 元素
                var gifPlayer = document.getElementById("gifPlayer");
                
                // 播放 GIF
                gifPlayer.play();
            })
        },
        // 查看日志
        // dialogVisible
        tranLogsView(){
            if(this.tranLogsData.length<=0){
                this.$message.warning("暂无运行日志");
                return
            }
            this.viewIndex=0
            this.viewData = this.tranLogsData
            this.dialogVisible = true
        },
	    tranErrorsView(){
            // console.log(this.tranErrorsData,456654)
            if(this.tranErrorsData.length<=0){
                this.$message.warning("暂无错误日志");
                return
            }
            this.viewIndex=1
            this.viewData =   this.tranErrorsData
            this.dialogVisible = true
        },
        // 清空运行和异常日志
        handleClick() {
            this.tranLogsData = [];
            this.tranErrorsData = [];
        },
        // 表格展开
        handleExpand(row) {
            this.$refs.relationshipTable.toggleRowExpansion(row);
        },
        // 判断是不是数字
        isNumeric(value) {
            return !isNaN(parseFloat(value)) && isFinite(value);
        },
        // 位置调换
        handleBlur(e, index) {
            let flag = this.isNumeric(e);
            if (flag) {
                //是数字
                if (Number(e) <= 1) {
                    let data = JSON.parse(
                        JSON.stringify(this.tableData[index])
                    );
                    this.tableData.splice(index, 1);
                    this.tableData.unshift(data);
                } else {
                    let data = JSON.parse(
                        JSON.stringify(this.tableData[index])
                    );
                    this.tableData.splice(index, 1);
                   this.$nextTick(()=>{
                    this.tableData.splice(Number(e)-1, 0, data);
                   })
                }
            } else {
                let data = JSON.parse(JSON.stringify(this.tableData[index]));
                this.tableData.splice(index, 1);
                this.tableData.push(data);
            }
           this.$nextTick(() => {
            this.tableData.forEach((item, ind) => {
                item.index = ind + 1;
            });
           })
        },
        // 修改索引事件
        handleInput(e, ind) {
            this.tableData[ind].index = e.replace(/\D/g, "");
            if (!e || e === "") {
                this.$message.error("请输入序号,若不输入将自动放置最后");
            }
        },
        // 添加特殊标志，表示class
        upNamess(name) {
            return "#@!" + name.substring(0, name.lastIndexOf("]") + 1);
        },
        // 修改name
        upNames(name) {
            return "!@#" + name.substring(0, name.lastIndexOf("]") + 1);
        },
        handleDragUpss() {
            let body = document.body;
            // if (this.upName != "") {
            //     body.style.cursor = "move";
            // } else {
            body.style.cursor = "default";
            this.startName = "";
            // }
            window._getAction1 = () => {
                return this.upName;
            };
            document
                .querySelectorAll(".el-tree-node__content")
                .forEach(function (element) {
                    element.style.cursor = "default";
                    // }
                });
            if (
                document.getElementsByName(this.classStartName) &&
                document.getElementsByName(this.classStartName).length > 0
            ) {
                let ele = document.getElementsByName(this.classStartName);
                ele[0].style.color = "#606266";
                this.classStartName = "";
            }
        },
        // 鼠标移动
        handleDragMove() {
            let body = document.body;
            if (this.startName != "") {
                body.style.cursor = "move";
            } else {
                body.style.cursor = "default";
            }
            window._getAction = () => {
                return this.startName;
            };
            document
                .querySelectorAll(".el-tree-node__content")
                .forEach(function (element) {
                    // 这里对每个element做操作
                    if (window._getAction() && window._getAction() != "") {
                        element.style.cursor = "move";
                    } else {
                        element.style.cursor = "default";
                    }
                });
        },
        // multipleSelection
        delTableData() {
            if (this.multipleSelection.length <= 0) {
                this.$message.error("请选择删除的数据");
                return;
            }
            this.tableData = this.tableData.filter(
                (item) =>
                    !this.multipleSelection.some((ele) => ele.id === item.id)
            );
            this.tableData.forEach((item, ind) => {
                item.index = ind + 1;
            });
        },
        // 对应关系多选
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 手动添加对应关系
        addTableData() {
            let ss = {
                sourcePath: "",
                targetPath: "",
                relationShip: 1,
                sourcePathCheck: false, //false
                targetPathCheck: false,
                id: new Date().getTime(),
                Options: {
                    KeyInitIndex: 0, //自动生成的元素的起始索引,默认为0
                    AddElementsOption: "1", //1:追加新元素到数组/对象 2：替换数组/对象的原有属性  默认为1
                    TranOP: "1", //1:将源子元素复制到目标 2：依据源元素在目标构建同等数量的目标子元素，且如果目标的子元素存在相应的一对一映射【TranWay=2】,则创建源和目标的一对一映射 默认为1
                    TranWay: "1", //1：交叉映射 2：一对一映射,仅在当前映射为规则映射（包含*、[*]）和上级元素指定 【TranOP=2】 时生效，否则按交叉映射执行  默认为1
                },
            };
            if (this.tableData.length <= 0) {
                ss.index = 1;
            } else {
                ss.index = this.tableData.length + 1;
            }

            this.tableData.push(ss);
        },
        // 生成报文
        generateMessage() {
            // if (!this.resultTemplate) {
            //     this.$message.error("请导入转换信息");
            //     return;
            // }

            try {
                if (!this.resultTemplateDom) {
                    this.$message.error("请导入转换信息");
                    return;
                }
                this.resultTemplate = this.resultTemplateDom.get();
                if (!this.resultTemplate) {
                    this.$message.error("请导入转换信息");
                    return;
                }
            } catch {
                this.$message.error("请导入转换信息");
                return;
            }

            try {
                let data = JSON.parse(
                    JSON.stringify(this.messageTemplateDom.get())
                );

                // let data = JSON.parse(JSON.stringify(this.messageTemplate));
                let relationshipData = JSON.parse(
                    JSON.stringify(this.resultTemplate)
                );
                let mappingdata = relationshipData.mappings;
                if (!Array.isArray(mappingdata) || mappingdata.length <= 0) {
                    this.$message.error("请导入正确的转换信息");
                    return;
                }

                let mappings = JSON.parse(JSON.stringify(mappingdata));
                // 源
                let jsonOrg = JSON.parse(JSON.stringify(data));
                // 目标
                let jsonAim = JSON.parse(
                    JSON.stringify(relationshipData.jsonAim)
                );
                let jsonTranferUtil = new JsonTranferUtil(
                    jsonOrg,
                    jsonAim,
                    mappings
                );
                // 检验
                let result = jsonTranferUtil.checkJsonMapping();
                // console.log(result,123321);
                let OrgJsonPath = [];
                let AimJsonPath = [];
                let message = "";
                this.tranErrorsData = result.runtimeErrors
                result.compileErrors.forEach((item) => {
                    if (item.OrgMsg && item.OrgMsg != "") {
                        OrgJsonPath.push(item.mapping.OrgJsonPath);
                        message += item.OrgMsg + "，";
                    }
                    if (item.AimMsg && item.AimMsg != "") {
                        AimJsonPath.push(item.mapping.AimJsonPath);
                        message += item.AimMsg + "，";
                    }
                });
                if (OrgJsonPath.length == 0 && AimJsonPath.length == 0) {
                    this.messageedTemplateDom.set(jsonTranferUtil.tranJson());
                    // this.messageedTemplate = jsonTranferUtil.tranJson();
                } else {
                    let errorMessage = message;
                    this.$message.error(
                        errorMessage.substring(0, errorMessage.length - 1)
                    );
                }
                this.tranLogsData = jsonTranferUtil.getTranLogs();
            } catch (error) {
                this.$message.error("JSON校验失败无法生成数据");
            }

        },
        // 导入转换对象
        importMes() {
            this.importDia = true;
            this.$nextTick(() => {
                if (!this.resultTemplateDom) {
                    var container4 =
                        document.getElementById("resultTemplateDom");
                    var options4 = {
                        mode: "code",
                    };
                    this.resultTemplateDom = new JSONEditor(
                        container4,
                        options4
                    );
                    try {
                        this.resultTemplateDom.set();
                    } catch {}
                }
            });
        },
        handleDragClicks(e) {
            let nodeTextParse = e.name;
            return nodeTextParse.substring(
                nodeTextParse.lastIndexOf("["),
                nodeTextParse.lastIndexOf("]") + 1
            );
        },
        // 获取路径
        fosourcePathCheck(index) {
            this.tableData[index].sourcePathCheck = false;
        },
        fotargetPathCheck(index) {
            this.tableData[index].targetPathCheck = false;
        },

        // 复制跳转
        copyRouter() {
            if (this.tableData.length <= 0) {
                this.$message.error("清先添加对应关系");
                return;
            }
            let mappings = [];
            this.tableData.forEach((item) => {
                let ss = {};
                ss.OrgJsonPath = item.sourcePath;
                ss.AimJsonPath = item.targetPath;
                ss.TranType = item.relationShip;
                mappings.push(ss);
            });
            // 源
            let jsonOrg = this.sourceTemplate;
            // 目标
            let jsonAim = this.targetTemplate;
            this.$router.push({
                path: "/convertpage",
                query: {
                    jsonOrg: jsonOrg,
                    jsonAim: jsonAim,
                    mappings: mappings,
                },
            });
        },
        // 预览
        preview() {
            this.finalTemplate = null;
            if (this.tableData.length <= 0) {
                this.$message.error("清先添加对应关系");
                return;
            }
            this.vertActiveName = "first";
            let mappings = [];
            let flag = true;
            let data = JSON.parse(JSON.stringify(this.tableData));
            data.forEach((item) => {
                if (item.sourcePath == "" || item.targetPath == "") {
                    flag = false;
                }
                let ss = {};
                ss.OrgJsonPath = item.sourcePath;
                ss.AimJsonPath = item.targetPath;
                ss.TranType = item.relationShip;
                ss.Options = item.Options;
                mappings.push(ss);
            });
            if (!flag) {
                this.$message.error("源路径或目标路径不能为空");
                return;
            }
            let mappingDeep = JSON.parse(JSON.stringify(mappings));
            // 源
            let jsonOrg = JSON.parse(JSON.stringify(this.sourceTemplate));
            // 目标
            let jsonAim = JSON.parse(JSON.stringify(this.targetTemplate));
            let jsonTranferUtil = new JsonTranferUtil(
                jsonOrg,
                jsonAim,
                mappings
            );
            let newJsonOrg = jsonTranferUtil.getSimpleOrgJson();
            // 检验
            let result = jsonTranferUtil.checkJsonMapping();
            // console.log(result,123321);
            let OrgJsonPath = [];
            let AimJsonPath = [];
            let message = "";
            this.tranErrorsData = result.runtimeErrors
            result.compileErrors.forEach((item) => {
                if (item.OrgMsg && item.OrgMsg != "") {
                    OrgJsonPath.push(item.mapping.OrgJsonPath);
                    message += item.OrgMsg + "，";
                }
                if (item.AimMsg && item.AimMsg != "") {
                    AimJsonPath.push(item.mapping.AimJsonPath);
                    message += item.AimMsg + "，";
                }
            });
            if (OrgJsonPath.length == 0 && AimJsonPath.length == 0) {
                this.previewTemplate = jsonTranferUtil.tranJson();
                this.previewDia = true;
                this.finalTemplateKey = new Date().getTime();
                this.$nextTick(() => {
                    this.finalTemplate = {
                        jsonOrg: newJsonOrg,
                        jsonAim:  JSON.parse(JSON.stringify(this.targetTemplate)),
                        mappings: mappingDeep,
                    };
                });
            } else {
                if (OrgJsonPath.length > 0) {
                    this.tableData.forEach((item) => {
                        let a = OrgJsonPath.filter((it) => {
                            return it == item.sourcePath;
                        });
                        if (a.length > 0) {
                            item.sourcePathCheck = true;
                        }
                    });
                }
                if (AimJsonPath.length > 0) {
                    this.tableData.forEach((item) => {
                        let a = AimJsonPath.filter((it) => {
                            return it == item.targetPath;
                        });
                        if (a.length > 0) {
                            item.targetPathCheck = true;
                        }
                    });
                }
                let errorMessage = message;
                this.$message.error(
                    errorMessage.substring(0, errorMessage.length - 1)
                );
            }
            this.tranLogsData = jsonTranferUtil.getTranLogs();
        },
        // 检验
        inspect() {
            if (this.tableData.length <= 0) {
                this.$message.error("清先添加对应关系");
                return;
            }
            let mappings = [];
            let flag = true;
            this.tableData.forEach((item) => {
                if (item.sourcePath == "" || item.targetPath == "") {
                    flag = false;
                }
                let ss = {};
                ss.OrgJsonPath = item.sourcePath;
                ss.AimJsonPath = item.targetPath;
                ss.TranType = item.relationShip;
                ss.Options = item.Options;
                mappings.push(ss);
            });
            if (!flag) {
                this.$message.error("源路径或目标路径不能为空");
                return;
            }
            // 源
            let jsonOrg = JSON.parse(JSON.stringify(this.sourceTemplate));
            // 目标
            let jsonAim = JSON.parse(JSON.stringify(this.targetTemplate));
            let jsonTranferUtil = new JsonTranferUtil(
                jsonOrg,
                jsonAim,
                mappings
            );
            // 检验
            let result = jsonTranferUtil.checkJsonMapping(); 
            // console.log(result,123321);
            let OrgJsonPath = [];
            let AimJsonPath = [];
            let message = "";
            this.tranErrorsData = result.runtimeErrors
            result.compileErrors.forEach((item) => {
                if (item.OrgMsg && item.OrgMsg != "") {
                    OrgJsonPath.push(item.mapping.OrgJsonPath);
                    message += item.OrgMsg + "，";
                }
                if (item.AimMsg && item.AimMsg != "") {
                    AimJsonPath.push(item.mapping.AimJsonPath);
                    message += item.AimMsg + "，";
                }
            });
            if (OrgJsonPath.length == 0 && AimJsonPath.length == 0 &&result.runtimeErrors.length==0) {
                this.$message.success("校验通过");
            } else {
                if (OrgJsonPath.length > 0) {
                    this.tableData.forEach((item) => {
                        let a = OrgJsonPath.filter((it) => {
                            return it == item.sourcePath;
                        });
                        if (a.length > 0) {
                            item.sourcePathCheck = true;
                        }
                    });
                }
                if (AimJsonPath.length > 0) {
                    this.tableData.forEach((item) => {
                        let a = AimJsonPath.filter((it) => {
                            return it == item.targetPath;
                        });
                        if (a.length > 0) {
                            item.targetPathCheck = true;
                        }
                    });
                }
               
                let errors=""
                if(result.runtimeErrors.length>0){
                    result.runtimeErrors.forEach((item)=>{
                    errors+=item+ "，";
                    })
                }
                let errorMessage = message+errors
                this.$message.error(
                    errorMessage.substring(0, errorMessage.length - 1)
                );
            }
            this.tranLogsData = jsonTranferUtil.getTranLogs();
        },
        // 数据转换
        generateTree(obj, path = "", type) {
            let tree = [];
            for (const key in obj) {
                // 创建当前路径
                let currentPath = path ? `${path}.${key}` : key;
                // 创建树节点
                const node = {
                    name: currentPath,
                    key: key,
                    value: obj[key],
                    children: [],
                };
                if (type == "target") {
                    this.targetPathData.push("#@!" + currentPath);
                    if (currentPath.indexOf("]") != -1) {
                        this.targetPathData.push(
                            "#@!" +
                                currentPath.substring(
                                    0,
                                    currentPath.lastIndexOf("]") + 1
                                )
                        );
                    }
                } else if (type == "source") {
                    this.sourcePathData.push("#@!" + currentPath);
                    if (currentPath.indexOf("]") != -1) {
                        this.sourcePathData.push(
                            "!@#" +
                                currentPath.substring(
                                    0,
                                    currentPath.lastIndexOf("]") + 1
                                )
                        );
                    }
                }
                // 检查属性是否是对象，并且不是null
                if (typeof obj[key] === "object" && obj[key] !== null) {
                    // 处理数组
                    if (Array.isArray(obj[key])) {
                        for (let i = 0; i < obj[key].length; i++) {
                            node.children.push(
                                this.generateTree(
                                    obj[key][i],
                                    `${currentPath}[${i}]`,
                                    type
                                )
                            );
                        }
                    } else {
                        // 处理对象，递归调用生成子树
                        node.children = this.generateTree(
                            obj[key],
                            currentPath,
                            type
                        );
                    }
                    // 如果没有子元素，就删除children这个属性
                    if (node.children.length === 0) {
                        delete node.children;
                    }
                }
                // 将节点添加到树中
                tree.push(node);
            }
            return tree;
        },
        clearStartName() {
            this.startName = "";
            if (this.sourcePathData && this.sourcePathData.length > 0) {
                this.sourcePathData = Array.from(new Set(this.sourcePathData));
                this.sourcePathData.forEach((item) => {
                    let ele = document.getElementsByName(item);
                    if (ele && ele.length > 0) {
                        ele[0].style.color = "#606266";
                    }
                });
            }
            let body = document.body;
            body.style.cursor = "default";
            if (
                document.getElementsByName(this.classStartName) &&
                document.getElementsByName(this.classStartName).length > 0
            ) {
                let ele = document.getElementsByName(this.classStartName);
                ele[0].style.color = "#606266";
                this.classStartName = "";
            }
        },
        // 鼠标按下事件
        handleDragStart(e) {
            this.startName = e.target.getAttribute("name").substring(3);
            let ele = document.getElementsByName(e.target.getAttribute("name"));
            ele[0].style.color = "#2578FA";
            this.classStartName = e.target.getAttribute("name");
            if (this.targetPathData && this.targetPathData.length > 0) {
                this.targetPathData = Array.from(new Set(this.targetPathData));
                this.targetPathData.forEach((item) => {
                    let ele = document.getElementsByName(item);
                    if (ele && ele.length > 0) {
                        ele[0].style.color = "#67C23A";
                    }
                });
            }
        },
        // 源结构索引拖动
        handleDragStartIndex(e) {
            this.startName = e.target.getAttribute("name").substring(3);
            let ele = document.getElementsByName(e.target.getAttribute("name"));
            ele[0].style.color = "#2578FA";
            this.classStartName = e.target.getAttribute("name");
            if (this.targetPathData && this.targetPathData.length > 0) {
                this.targetPathData = Array.from(new Set(this.targetPathData));
                this.targetPathData.forEach((item) => {
                    let ele = document.getElementsByName(item);
                    if (ele && ele.length > 0) {
                        ele[0].style.color = "#67C23A";
                    }
                });
            }
        },
        // 目标结构索引拖动
        handleDragUpIndex(e) {
            if (this.startName != "") {
                this.upName = e.target.getAttribute("name").substring(3);
                var tooltip = document.getElementById("tooltip");
                tooltip.style.left = e.pageX + 10 + "px"; // 鼠标位置右偏10像素
                tooltip.style.top = e.pageY + 10 + "px"; // 鼠标位置下偏10像素
                this.relationShip = "";
                this.startNameCopy = JSON.parse(JSON.stringify(this.startName));
                this.startName = "";
            }
        },
        handleDragUpIndexRecursion(e, event) {
            if (this.startName != "") {
                this.upName = e.substring(3);
                var tooltip = document.getElementById("tooltip");
                tooltip.style.left = event.pageX + 10 + "px"; // 鼠标位置右偏10像素
                tooltip.style.top = event.pageY + 10 + "px"; // 鼠标位置下偏10像素
                this.relationShip = "";
                this.startNameCopy = JSON.parse(JSON.stringify(this.startName));
                this.startName = "";
            }
        },
        handleDragStartIndexRecursion(e) {
            this.startName = e.substring(3);
            let ele = document.getElementsByName(e);
            ele[0].style.color = "#2578FA";
            this.classStartName = e;
            if (this.targetPathData && this.targetPathData.length > 0) {
                this.targetPathData = Array.from(new Set(this.targetPathData));
                this.targetPathData.forEach((item) => {
                    let ele = document.getElementsByName(item);
                    if (ele && ele.length > 0) {
                        ele[0].style.color = "#67C23A";
                    }
                });
            }
        },
        handleDragStartRecursion(e) {
            this.startName = e.target.getAttribute("name").substring(3);
            let ele = document.getElementsByName(e.target.getAttribute("name"));
            ele[0].style.color = "#2578FA";
            this.classStartName = e.target.getAttribute("name");
            if (this.targetPathData && this.targetPathData.length > 0) {
                this.targetPathData = Array.from(new Set(this.targetPathData));
                this.targetPathData.forEach((item) => {
                    let ele = document.getElementsByName(item);
                    if (ele && ele.length > 0) {
                        ele[0].style.color = "#67C23A";
                    }
                });
            }
        },
        clearStartNameRecursion() {
            this.startName = "";
        },
        // 鼠标松开
        handleDragUp(e) {
            if (this.startName != "") {
                this.upName = e.target.getAttribute("name").substring(3);
                var tooltip = document.getElementById("tooltip");
                tooltip.style.left = e.pageX + 10 + "px"; // 鼠标位置右偏10像素
                tooltip.style.top = e.pageY + 10 + "px"; // 鼠标位置下偏10像素
                this.relationShip = "";
                this.startNameCopy = JSON.parse(JSON.stringify(this.startName));
                this.startName = "";
            }
            if (
                document.getElementsByName(this.classStartName) &&
                document.getElementsByName(this.classStartName).length > 0
            ) {
                let ele = document.getElementsByName(this.classStartName);
                ele[0].style.color = "#606266";
                this.classStartName = "";
            }
        },
        handleDragUpRecursion(e) {
            if (this.startName != "") {
                this.upName = e.target.getAttribute("name").substring(3);
                var tooltip = document.getElementById("tooltip");
                tooltip.style.left = e.pageX + 10 + "px"; // 鼠标位置右偏10像素
                tooltip.style.top = e.pageY + 10 + "px"; // 鼠标位置下偏10像素
                this.relationShip = "";
                this.startNameCopy = JSON.parse(JSON.stringify(this.startName));
                this.startName = "";
            }
        },
        // 下方添加对应关系
        addShip(index) {
            let ss = {
                sourcePath: "",
                targetPath: "",
                relationShip: 1,
                sourcePathCheck: false, //false
                targetPathCheck: false,
                id: new Date().getTime(),
            };
            this.tableData.splice(index + 1, 0, ss);
            this.tableData.forEach((item, ind) => {
                item.index = ind + 1;
            });
        },
        // 删除对应关系
        delShip(e) {
            this.tableData.splice(e, 1);
            this.tableData.forEach((item, ind) => {
                item.index = ind + 1;
            });
        },
        // 选择关系
        showShip(e) {
            // tableData
            let ss = {
                sourcePath: this.startNameCopy,
                targetPath: this.upName,
                relationShip: this.relationShipOptions.filter((item) => {
                    return item.value == e;
                })[0].value,
                sourcePathCheck: false, //false
                targetPathCheck: false,
                id: new Date().getTime(),
                Options: {
                    KeyInitIndex: 0, //自动生成的元素的起始索引,默认为0
                    AddElementsOption: "1", //1:追加新元素到数组/对象 2：替换数组/对象的原有属性  默认为1
                    TranOP: "1", //1:将源子元素复制到目标 2：依据源元素在目标构建同等数量的目标子元素，且如果目标的子元素存在相应的一对一映射【TranWay=2】,则创建源和目标的一对一映射 默认为1
                    TranWay: "1", //1：交叉映射 2：一对一映射,仅在当前映射为规则映射（包含*、[*]）和上级元素指定 【TranOP=2】 时生效，否则按交叉映射执行  默认为1
                },
            };
            if (this.tableData.length <= 0) {
                ss.index = 1;
            } else {
                ss.index = this.tableData.length + 1;
            }
            this.tableData.push(ss);
            this.cancelShip();
        },
        // 关闭关系弹框
        cancelShip() {
            var tooltip = document.getElementById("tooltip");
            tooltip.style.left = -999 + "px"; // 鼠标位置右偏10像素
            tooltip.style.top = -999 + "px"; // 鼠标位置下偏10像素
            this.startName = "";
            this.upName = "";
        },
        // 源模板格式化
        sourceFormatCode() {
            try {
                JSON.parse(this.sourceTemplate);
                this.$message.success("JSON校验成功");
            } catch (error) {
                this.$message.error("JSON校验失败");
            }
        },
        // 判断路径是否在对象上
        isPathInObject(obj, path) {
            const parts = path.replace(/\[(\w+)\]/g, ".$1").split("."); // 将索引转换为点分隔
            let current = obj;

            for (let i = 0; i < parts.length; i++) {
                if (current[parts[i]] === undefined) {
                    return false;
                }
                current = current[parts[i]];
            }

            return true;
        },
        // 源生成结构
        sourceStructure() {
            try {
                this.sourceTemplate = this.sourceTemplateDom.get();
                this.sourcePathData = [];
                let data = { root: this.sourceTemplate };
                this.sourceData = this.generateTree(data, "", "source");
                this.finalTemplate = null;
                // setTimeout(() => {
                if (
                    this.tableData &&
                    this.tableData.length > 0 &&
                    this.sourceTemplate
                ) {
                    this.tableData.forEach((item) => {
                        if (item.sourcePath == "root") {
                            item.sourcePathCheck = false;
                        } else {
                            let newPath = JSON.parse(
                                JSON.stringify(item.sourcePath)
                            );
                            let newPaths = newPath.replace(/\[\*\]/g, "[0]");
                            newPaths = newPaths.substring(5);
                            let flag = this.isPathInObject(
                                this.sourceTemplate,
                                newPaths
                            );
                            if (flag == false) {
                                item.sourcePathCheck = true;
                            } else {
                                item.sourcePathCheck = false;
                            }
                        }
                    });
                }
                // }, 100);
            } catch (error) {
                this.$message.error("JSON校验失败无法生成结构");
            }
        },
        // 源清空
        clearSourceTemplate() {
            try {
                this.sourceTemplateDom.set();
            } catch {}
            // this.sourceTemplate = null;
        },
        // 目标模板格式化
        targetFormatCode() {
            try {
                JSON.parse(this.targetTemplate);
                this.$message.success("JSON校验成功");
            } catch (error) {
                this.$message.error("JSON校验失败");
            }
        },
        // 目标生成结构
        targetStructure() {
            try {
                this.targetTemplate = this.targetTemplateDom.get();
                this.targetPathData = [];
                let data = { root: this.targetTemplate };
                this.targetData = this.generateTree(data, "", "target");
                this.finalTemplate = null;
                // setTimeout(() => {
                if (
                    this.tableData &&
                    this.tableData.length > 0 &&
                    this.targetTemplate
                ) {
                    this.tableData.forEach((item) => {
                        if (item.targetPath == "root") {
                            item.targetPathCheck = false;
                        } else {
                            let newPath = JSON.parse(
                                JSON.stringify(item.targetPath)
                            );
                            let newPaths = newPath.replace(/\[\*\]/g, "[0]");
                            newPaths = newPaths.substring(5);
                            let flag = this.isPathInObject(
                                this.targetTemplate,
                                newPaths
                            );
                            if (flag == false) {
                                item.targetPathCheck = true;
                            } else {
                                item.targetPathCheck = false;
                            }
                        }
                    });
                }
                // }, 100);
            } catch (error) {
                this.$message.error("JSON校验失败无法生成结构");
            }
        },
        // 目标清空
        clearTargetTemplate() {
            // this.targetTemplate = "";
            try {
                this.targetTemplateDom.set();
            } catch {}
        },
    },
};
</script>
  <style scoped lang="scss">
::v-deep .jsoneditor-outer {
    height: 400px;
}
::v-deep .el-tree-node__content {
    height: 150%;
}
.treeClass {
    display: inline-block;
}

::v-deep #jsoneditor .jsoneditor-vue {
    height: 300px !important;
}
::v-deep #jsoneditor .ace-jsoneditor {
    height: 310px !important;
}
::v-deep #jsoneditor .jsoneditor-separator {
    display: none;
}

::v-deep #jsoneditor .jsoneditor-redo {
    display: none;
}
::v-deep #jsoneditor1 .jsoneditor-vue {
    height: 300px !important;
}
::v-deep #jsoneditor1 .ace-jsoneditor {
    height: 310px !important;
}
::v-deep #jsoneditor1 .jsoneditor-separator {
    display: none;
}

::v-deep #jsoneditor1 .jsoneditor-redo {
    display: none;
}

::v-deep .comDrawer .jsoneditor-vue {
    height: calc(100vh - 180px) !important;
}
::v-deep .comDrawer .ace-jsoneditor {
    height: calc(100vh - 240px) !important;
}

::v-deep .impDrawer .jsoneditor-outer {
    height: calc(100vh - 150px) !important;
}
// ::v-deep .impDrawer .ace-jsoneditor {
//     height: calc(100vh - 195px) !important;
// }
::v-deep .impDrawer .jsoneditor-separator {
    display: none;
}

::v-deep .impDrawer .jsoneditor-redo {
    display: none;
}

::v-deep .editorBottom .jsoneditor-vue {
    height: calc(100vh - 140px) !important;
}
::v-deep .editorBottom .ace-jsoneditor {
    height: calc(100vh - 185px) !important;
}
::v-deep .editorBottom .jsoneditor-outer {
    height: 100%;
}

::v-deep .editorBottom .jsoneditor-separator {
    display: none;
}

::v-deep .editorBottom .jsoneditor-redo {
    display: none;
}

::v-deep .editorBottom1 .jsoneditor-vue {
    height: calc(100vh - 140px) !important;
}
::v-deep .editorBottom1 .ace-jsoneditor {
    height: calc(100vh - 185px) !important;
}
::v-deep .editorBottom1 .jsoneditor-outer {
    height: 100%;
}

::v-deep .editorBottom1 .jsoneditor-separator {
    display: none;
}

::v-deep .editorBottom1 .jsoneditor-redo {
    display: none;
}

::v-deep .jsoneditor-poweredBy {
    display: none;
}
.structureStyle {
    background-color: #eeeeee;
}
/* 覆盖点击后的背景色 */
::v-deep .el-tree .el-tree-node.is-current .el-tree-node__content {
    background-color: transparent !important;
}

/* 覆盖鼠标悬停的背景色 */
::v-deep .el-tree .el-tree-node:hover .el-tree-node__content {
    background-color: transparent !important;
}
.custom-cursor {
    position: absolute;
    pointer-events: none; /* 防止鼠标样式影响交互 */
    z-index: 9999; /* 确保鼠标样式位于页面最上层 */
}
.emptyImg{
    margin: auto;
    height:160px;
    width: 160px;
    background-size: 100% 100%;
    background-image: url("./yvkong.png");
    opacity:  0.07
}
// ::v-deep .el-tree__empty-block{
//     margin: 0 auto;
//     margin-top: 15vh;
//     height: 60px;
//     width: 60px;
//     background-size: 100% 100%;
//     background-repeat: no-repeat;
//     background-image: url("./yvkong.png");
// }
::v-deep .el-tree__empty-text{
    color: #e7e9ee;
}

</style>
  